class VtStickyAtc extends HTMLElement {
  connectedCallback() {
    this.atcLabel = this.dataset.atcLabel || 'Add to cart';
    this.variantInput = this.querySelector('.product-variant-id');
    this.submitButton = this.querySelector('.product-form__submit');
    this.labelEl = this.querySelector('[data-vt-sticky-atc-label]');
    this.variantEl = this.querySelector('[data-vt-sticky-variant]');
    this.imageEl = this.querySelector('[data-vt-sticky-image]');

    this.observeBuyButtons();
    this.bindVariantUpdates();
  }

  observeBuyButtons() {
    const buyBlock =
      document.querySelector('.vt-pdp__buy-buttons') || document.querySelector('.product__info-container');

    if (!buyBlock) return;

    this.visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('is-visible', !entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '-72px 0px 0px 0px' }
    );

    this.visibilityObserver.observe(buyBlock);
  }

  bindVariantUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      if (!variant) return;
      this.updateVariant(variant);
    });
  }

  disconnectedCallback() {
    this.visibilityObserver?.disconnect();
    this.variantUnsubscriber?.();
  }

  updateVariant(variant) {
    if (this.variantInput) {
      this.variantInput.value = variant.id;
      this.variantInput.disabled = !variant.available;
    }

    if (this.submitButton) {
      this.submitButton.disabled = !variant.available;
    }

    if (this.labelEl) {
      this.labelEl.textContent = variant.available
        ? this.atcLabel
        : window.variantStrings?.soldOut || 'Sold out';
    }

    if (this.variantEl) {
      const hasNamedVariant = variant.title && variant.title !== 'Default Title';
      this.variantEl.textContent = hasNamedVariant ? variant.title : '';
      this.variantEl.hidden = !hasNamedVariant;
    }

    const preview = variant.featured_media?.preview_image;
    if (this.imageEl && preview?.src) {
      this.imageEl.src = preview.src;
      if (preview.alt) this.imageEl.alt = preview.alt;
    }
  }
}

customElements.define('vt-sticky-atc', VtStickyAtc);
